import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=34280451&scoped=true"
import script from "./Workflows.vue?vue&type=script&lang=ts"
export * from "./Workflows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34280451",
  null
  
)

export default component.exports